// src/actions/SelectedService.ts
export const SET_SELECTED_SERVICE = "SET_SELECTED_SERVICE";

export const setSelectedService = (payload: { data: any; columns: string[] }) => ({
  type: SET_SELECTED_SERVICE,
  payload,
});
